import styled from "styled-components";
import {
	DESKTOP_SM_BP,
	TABLET_BP,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_BACKGROUND_GREEN,
} from "@website-builder/utilities-index";

export const SocialMediaImagesContainer = styled.div`
	padding: 80px 5px 80px 5px;
	background-color: ${COLOR_BACKGROUND_GREEN};
	.imagesWrapper {
		display: flex;
		justify-content: center;
		flex-flow: wrap;
	}
	.socialMediaImages {
		padding: 5px 7px;
	}
	.buttonWrapper {
		text-align: center;
		margin-top: 40px;
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) and (min-width: ${TABLET_BP}px) {
		padding: 50px 5px 50px 5px;
		.socialMediaImages {
			padding: 2px 4px;
		}
		.image {
			width: 173px;
			height: 173px;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 40px 5px 40px 5px;
		.socialMediaImages {
			padding: 5px 4px;
		}
		.image {
			width: 136px;
			height: 136px;
		}
		.buttonWrapper {
			margin-top: 30px;
		}
	}
`;

export const Heading = styled.div`
	text-align: center;
	font-size: 28px;
	font-weight: ${FONT_WT_MEDIUM};
	line-height: 1;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-bottom: 50px;

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) and (min-width: ${TABLET_BP}px) {
		font-size: 26px;
		line-height: 1.08;
		margin-bottom: 30px;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 24px;
		line-height: 1.17;
		margin-bottom: 20px;
	}
`;
